import { useTranslation } from 'react-i18next';

import { Flex, Heading, Text } from '@chakra-ui/react';
import { CheckedIcon } from '@udacity/chakra-uds-icons';

import { SectionHeader } from '~/components/section-header';
import { HomepageComparisonTable } from '~/features/homepage/components/homepage-comparison-table';

export function HomepageComparisonSection() {
  const { t } = useTranslation();

  return (
    <Flex
      aria-labelledby='homepage-comparison-heading'
      as='section'
      flexDirection='column'
      gap={{
        base: '32px',
        md: '56px',
      }}
    >
      <SectionHeader
        color='grey.500'
        descriptionSlot={<Text color='grey.500'>{t('home.comparison.description')}</Text>}
        iconSlot={<CheckedIcon boxSize='24px' color='grey.500' />}
        subtitle={t('home.comparison.subtitle') ?? ''}
        containerProps={{
          margin: '0 auto',
          maxWidth: '936px',
          width: '100%',
        }}
        titleSlot={
          <Heading
            as='h2'
            fontWeight='600'
            id='homepage-comparison-heading'
            lineHeight='1.1'
            fontSize={{
              base: '2.25rem',
              md: '3.375rem',
            }}
          >
            {t('home.comparison.title')}
          </Heading>
        }
      />
      <HomepageComparisonTable />
    </Flex>
  );
}
